import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import type { CurrentUser } from './lib/auth';
import { routeTree } from './routeTree.gen';

/** `user` is the session loaded on start-up (null = signed out); see main.tsx. */
export function createAppRouter(queryClient: QueryClient, user: CurrentUser | null) {
  return createRouter({
    routeTree,
    context: { queryClient, auth: { user } },
    defaultPreload: 'intent',
    scrollRestoration: true,
  });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof createAppRouter>;
  }
}
